export enum ObjectType {
    WordCard = "WordCard",
    AnswerCard = "AnswerCard",
    ScissorsTool = "ScissorsTool"
}